import { render, staticRenderFns } from "./AuthorsCommentsList.vue?vue&type=template&id=16be4a56&scoped=true"
import script from "./AuthorsCommentsList.vue?vue&type=script&lang=js"
export * from "./AuthorsCommentsList.vue?vue&type=script&lang=js"
import style0 from "./AuthorsCommentsList.vue?vue&type=style&index=0&id=16be4a56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16be4a56",
  null
  
)

export default component.exports